import request from '@/utils/request';

// 登录接口
export function login(data) { return request({ url: '/loginApp', method: 'post', data }) }
export function getManagerInfoByArea(data) { return request({ url: '/screen/getManagerInfoByArea', method: 'get', params: data }) }